<template>
  <el-table ref="userOfficeTable" stripe :data="filteredOffices" style="width: 100%">
    <el-table-column property="storeNum" label="Store #" sortable width="100"></el-table-column>
    <el-table-column property="efin" label="EFIN" width="100"></el-table-column>
    <el-table-column property="address" label="Address">
      <template slot-scope="scope">
        <el-row class="normal-word-wrap">
          <el-col :span="24">
            {{ formatAddress(scope.row) }}
          </el-col>
        </el-row>
      </template>
    </el-table-column>
    <el-table-column property="phone" label="Phone" width="200"></el-table-column>
  </el-table>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import filter from 'lodash/filter';
import includes from 'lodash/includes';

export default {
  name: 'UserOfficesTable',
  props: {
    officeIds: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    ...mapActions('Lookup', ['getOffices']),
    formatAddress(office) {
      if (office) {
        const address = office.address || '';
        const city = office.city || '';
        const state = office.state || '';
        const zip = office.zip || '';

        let addressString = '';
        if (address.length) {
          addressString += `${address}\n`;
        }
        if (city.length) {
          addressString += city + (state.length ? ', ' : '');
        }

        addressString += `${state} ${zip}`;
        return addressString;
      }
      return '';
    },
  },
  watch: {
    filteredReferrals() {
      this.autoSelectAcceptedRows();
    },
  },
  computed: {
    ...mapGetters('Lookup', [
      'allOffices',
    ]),
    filteredOffices() {
      return filter(this.allOffices, office => includes(this.officeIds, office.id));
    },
  },
  mounted() {
    this.isLoading = true;
    this.getOffices().finally(() => {
      this.isLoading = false;
    });
  },
};

</script>

<style lang="scss" scoped>
  .client-header {
    h2 {
      margin: 0;
      padding: 0 5px;
      font-size:1.8em;

      span {
        font-weight: normal;
        color: #999;
        font-size: 0.75em;
        text-transform: uppercase;
      }
    }
  }
</style>
